import React, { useCallback } from 'react';
import { Header } from 'common/components/Header';
import { FormikOnSubmit } from 'lib/formik.utils';
import { BusinessPartnerContext } from 'pages/BusinessPartnerManagement/BusinessPartnerContext';
import { useMutation, useQueryCache } from 'react-query';
import { BusinessPartnersAPI } from 'api/BusinessPartnersAPI';
import { QueryKey } from 'api/queryKey';
import { message } from 'antd';
import { useEnsureContext } from 'common/hooks';
import { BusinessPartnerPatientForm } from 'pages/BusinessPartnerManagement/BusinessPartnerPatientsManagement/shared/BusinessPartnerPatientForm';
import { BusinessPartnerPatientFormModel } from 'models/patient';
import { SaveButton } from 'common/components/SaveButton';
import { useHistory } from 'react-router';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { BusinessPartnerRoutes } from 'pages/BusinessPartnerManagement/businessPartnerRoutes';

export const BusinessPartnerRegisterPatientPage = () => {
  const bpContext = useEnsureContext(BusinessPartnerContext);
  const queryCache = useQueryCache();

  const [mutate, { isLoading }] = useMutation(
    BusinessPartnersAPI.registerNewPatient
  );

  const history = useHistory();
  const intlMessage = useFormatMessage();
  const removeSpacesFromForm = (formData: BusinessPartnerPatientFormModel) => {
    if (formData.phoneNumber !== null) {
      formData.phoneNumber = formData.phoneNumber

        .replace(/\s/g, '')
        .replace(/^0+/, '');
      formData.prefixCode = formData.prefixCode.replace(/\s/g, '');
    }
    return formData;
  };

  const handleSubmit: FormikOnSubmit<BusinessPartnerPatientFormModel> = useCallback(
    (formData, { resetForm }) => {
      const formDataToSend =
        formData.phoneNumber !== null
          ? removeSpacesFromForm(formData)
          : formData;
      mutate(
        {
          businessPartnerId: formDataToSend.partner
            ? formDataToSend.partner
            : bpContext.id,
          dto: formData,
        },
        {
          onSuccess: () => {
            resetForm();
            queryCache
              .invalidateQueries(QueryKey.BusinessPartnerPatientsList)
              .then();
            message.success(
              intlMessage(
                { id: 'patients.register.success' },
                {
                  firstName: formData.firstName,
                  lastName: formData.lastName,
                }
              )
            );
            history.push(`../${BusinessPartnerRoutes.Patients}`);
          },
        }
      ).then();
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [bpContext, mutate, queryCache]
  );

  return (
    <>
      <Header title={intlMessage({ id: 'patients.addNew' })} />
      <BusinessPartnerPatientForm onSubmit={handleSubmit}>
        <SaveButton loading={isLoading} />
      </BusinessPartnerPatientForm>
    </>
  );
};
